import CircularLoading from 'components/base/loading/CircularLoading';
import { pageUrl } from 'lib/mapper';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import queryString from 'query-string';
import { PmsActions, ProjectActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import { useDidUpdateEffect } from 'lib/utils';
import { makeCaseIdFnClinic, makeCaseIdFnLab } from 'lib/library';
import { isClinicUserSelector } from 'store/modules/user';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

export default function ProjectCreating() {
  const {
    user: { userGroupIdx: userId, groupCode, company },
    isClinicUser,
    projectInit: { projectCount: projectCount },
    projectInitSuccess,
    projectData,
    hasAlarm,
    projectFilesData: { fileData },
    projectFilesSuccess,
    copyProjectData,
    fetchCopyProjectSuccess,
    // editProjectData,
    // editProjectSuccess,
    createProjectData,
    createProjectSuccess,
    isReScan,
  } = useShallowAppSelector(state => ({
    user: state.user.user || {},
    isClinicUser: isClinicUserSelector(state),
    projectInit: state.project.initProject.data || { projectCount: {} },
    projectInitSuccess: state.project.initProject.success,
    projectFilesData: state.file.projectFiles.data || {},
    projectFilesSuccess: state.file.projectFiles.success,
    projectData: state.project.project.data,
    hasAlarm: state.project.hasAlarm,
    copyProjectData: state.project.copyProject.data,
    fetchCopyProjectSuccess: state.project.copyProject.success,
    editProjectData: state.project.editProject.data,
    editProjectSuccess: state.project.editProject.success,
    createProjectData: state.project.createProject.data,
    createProjectSuccess: state.project.createProject.success,
    isReScan: state.base.isReScan,
  }));
  const { t } = useTranslation();
  const { ipcRenderer } = window;
  const { pcode: projectCode } = useParams() as { pcode: string };
  const history = useHistory();
  const location = history.location;
  const { search } = location as {
    search: string;
  };
  const queryParse = queryString.parse(search);
  const pathTo = queryParse?.pathTo;
  const scanStart = Number(queryParse?.scanStart) || 0;
  const returnPath = queryParse?.returnPath || '';
  const prevProjectCode = projectData?.projectInfo?.projectCode || null;
  // const prevProjectId = projectData?.projectInfo?.projectId || null;
  const copyPartnerIdx = queryParse?.copyPartner;
  const copyFile = queryParse?.copyFile;
  const pageTab = Number(queryParse?.tab) || 0;

  const [prevProjectId, setPrevProjectId] = useState<string>('');

  let replaceTimeOut: any = '';
  useEffect(() => {
    console.log('HDS] prevProjectCode __________ ', prevProjectCode);
    console.log('HDS] projectCode __________ ', projectCode);
    console.log('HDS] copyPartnerIdx __________ ', copyPartnerIdx);
    console.log('HDS] copyFile __________ ', copyFile);
    console.log('HDS] scanStart  __________ ', scanStart);
    console.log('HDS] pageTab  __________ ', pageTab);
    console.log('HDS] prevProjectId  __________ ', prevProjectId);

    if (projectCode && !!pathTo) {
      // history;
      switch (pathTo) {
        case 'scanEdit':
          setTimeout(() => {
            history.push(`/project/detail/${projectCode}`, {
              isFromCreating: true,
            });
          }, 1000);
          break;
        case 'scanFinish':
          setTimeout(() => {
            history.push(`/project/detail/${projectCode}?tab=${pageTab}`, {
              isFromCreating: true,
            });
          }, 1000);
          break;
        case 'detail':
          if (prevProjectCode === projectCode) {
            console.log('PMS] [detail] 뒤로가기 ');
            ProjectActions.fetch_project_clear();
            history.goBack();
          } else {
            console.log('PMS] 1초뒤 이동 [detail] /project/detail/', projectCode);
            setTimeout(() => {
              // history.replace(`/project/detail/${projectCode}`);

              history.push(`/project/detail/${projectCode}?scanStart=${scanStart}&tab=${pageTab}`, {
                isFromCreating: true,
              });
            }, 1000);
            PmsActions.pms_ready(true);
          }
          break;
        case 'edit':
          console.log('PMS] 1초뒤 이동 [edit] /project/edit/', projectCode);
          setTimeout(() => {
            history.replace(`/project/edit/${projectCode}`);
          }, 1000);
          PmsActions.pms_ready(true);
          // if (prevProjectCode === projectCode) {
          //   console.log('PMS] [edit] 뒤로가기 ');
          //   ProjectActions.fetch_project_clear();
          //   history.goBack();
          // } else {
          //   console.log('PMS] 1초뒤 이동 [edit] /project/edit/', projectCode);
          //   setTimeout(() => {
          //     history.push(`/project/edit/${projectCode}`, { isFromCreating: true });
          //   }, 1000);
          //   PmsActions.pms_ready(true);
          // }
          break;
        case 'copy':
          if (prevProjectCode !== projectCode) {
            console.log('PMS] [copy] 뒤로가기 ');
            console.log('HDS] [copy] 뒤로가기 ');
            ProjectActions.fetch_project_clear();
            history.goBack();
          } else {
            console.log('HDS] PROJECT 복제ㅔㅔㅔㅔㅔㅔ');
            ProjectActions.init_project_request();
          }

          break;
        case 'copyFromList':
          ProjectActions.init_project_request();

          break;
        default:
          if (prevProjectCode === projectCode) {
            console.log('PMS] [default] 뒤로가기 ');
            ProjectActions.fetch_project_clear();
            history.goBack();
          } else {
            setTimeout(() => {
              // history.replace(`/project/detail/${projectCode}`);
              history.push(`/project/detail/${projectCode}`, { isFromCreating: true });
            }, 1000);
          }
          break;
      }
    } else {
      // ERROR: Time out 발생
      console.log('PMS] TIME OUT 발생 30초뒤 index로 이동');

      replaceTimeOut = setTimeout(() => {
        history.replace(pageUrl.dashboard.index);
      }, 30000);
    }

    return () => {
      clearTimeout(replaceTimeOut);
    };
  }, [projectCode]);

  useDidUpdateEffect(() => {
    if (!(!!projectInitSuccess && (!!isReScan || !!copyPartnerIdx || !!copyFile))) return;
    ProjectActions.fetch_copy_project_request(projectCode);
  }, [projectInitSuccess]);

  useDidUpdateEffect(() => {
    // if (!fetchCopyProjectSuccess || !copyProjectData || !isReScan) return;
    if (
      !(
        !!fetchCopyProjectSuccess &&
        !!copyProjectData &&
        (!!isReScan || !!copyPartnerIdx || !!copyFile)
      )
    )
      return;

    console.log('PMS] copyProjectData __________', copyProjectData);
    const projectInfo = copyProjectData.projectInfo;
    const patientInfo = projectInfo.patientInfo;
    const indication = projectInfo.indication;
    const projectCopyName = `${projectInfo.projectName}-copy` || '';

    let clinicProjectId: string = makeCaseIdFnClinic({
      newDate: 0,
      patientName: `${!!patientInfo?.firstName ? patientInfo.firstName : ''}${
        !!patientInfo?.lastName ? patientInfo.lastName : ''
      }${!!patientInfo?.identification ? patientInfo.identification : ''}`,
      groupCode: groupCode,
      caseCount: projectCount,
      // caseIdValue: projectInfo.projectName || '',
      caseIdValue: projectCopyName,
    })(1);

    let labProjectId: string = makeCaseIdFnLab({
      newDate: 0,
      companyName: projectInfo.clientName || '',
      caseCount: projectCount,
      // caseIdValue: projectInfo.projectName || '',
      caseIdValue: projectCopyName,
    })(1);

    const teethArr = indication.teeth.map((item: any) => {
      return {
        ...item,
        implantLibraryIdx: item?.implantLibrary?.implantLibraryIdx,
      };
    });

    setPrevProjectId(projectInfo.projectId);
    const submitData: any = {
      exocadVersion: 3,
      userIdx: userId,
      projectId: !!isClinicUser ? clinicProjectId : labProjectId,
      // projectName: projectInfo.projectName || '',
      projectName: projectCopyName,
      dueDate: moment.isMoment(projectInfo.dueDate) ? projectInfo.dueDate.unix() : null,
      senderMemo: projectInfo.senderMemo || '',
      newDate: null,
      patientCodeIdx: patientInfo?.patientCodeIdx,
      isMultidie: projectInfo.isMultidie,
      participant: {
        client: !isClinicUser ? projectInfo.clientIdx : userId,
        manager: projectInfo.managerIdx || '',
        userIdx: userId,
        partner: !!copyPartnerIdx ? copyPartnerIdx : null,
      },
      copyProjectCode: projectCode,
      copyProjectOption: !!copyPartnerIdx || copyFile === '1' ? ['INFO', 'FILE'] : [],
      remakeType: [],
      indication: {
        // teeth: indication.teeth,
        teeth: teethArr,
        bridge: indication.bridgeList,
        toothShade: indication.toothShade,
        scanmodeIdx: indication.scanmodeIdx,
        notation: indication.notation,
        restorationPonticDesign: indication.restorationPonticDesign,
        ceramicMetalDesign: indication.ceramicMetalDesign,
        occlusalSurfaceDesign: indication.occlusalSurfaceDesign,
      },
    };

    // console.log('PMS] submitData _________ ', submitData);
    console.log('HDS] submitData _________ ', submitData);

    ProjectActions.create_project_request(submitData);
  }, [fetchCopyProjectSuccess, copyProjectData]);

  useDidUpdateEffect(() => {
    if (!!createProjectSuccess && !!isReScan) {
      // ipcRenderer.send('setLatestOnlineProjectList', {});
      history.push(`/project/detail/${createProjectData?.projectInformation?.projectCode}`, {
        isFromCreating: true,
      });
      PmsActions.pms_ready(true);
    }

    if (!!createProjectSuccess) {
      if (!!copyPartnerIdx || copyFile === '1') {
        handleProjectFileCopy(createProjectData, returnPath);
      }
      if (copyFile === '0') {
        history.push(`/project/detail/${createProjectData?.projectInformation?.projectCode}`, {
          isFromCreating: true,
        });
      }
    }
  }, [createProjectSuccess, createProjectData]);

  const handleProjectFileCopy = async (projectData: any, returnPath: string | string[]) => {
    const result = await ipcRenderer.invoke('projectCopyAsync', {
      prevProjectId: prevProjectId,
      newProjectId: projectData?.projectInformation.projectId,
    });
    if (result.status)
      if (returnPath === 'detail') {
        history.push(`/project/detail/${projectData?.projectInformation?.projectCode}?tab=1`, {
          isFromCreating: true,
        });
      } else {
        history.push(`/project/detail/${projectData?.projectInformation?.projectCode}`, {
          isFromCreating: true,
        });
      }
  };

  return (
    <Styled.ProjectCreating>
      <CircularLoading />
    </Styled.ProjectCreating>
  );
}

const Styled = {
  ProjectCreating: styled.section`
    z-index: 100;
    background: transparent;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};
